<template>
  <div id="contact">
    <ContactMap class="map" />
    <a
      target="_blank"
      href="https://www.facebook.com/SoftSkillsAcademyBucharest"
    >
      <button class="buton">Contactează-ne</button>
    </a>
    <div id="title-contact">PERSOANE DE CONTACT</div>
    <div class="is-centered flex-box">
      <div
        class="column is-3"
        id="contact-cards"
        v-for="(obj, index) in contactPeople"
        :key="index"
      >
        <ContactPersonCard :contactPerson="obj"></ContactPersonCard>
      </div>
    </div>
  </div>
</template>

<script>
import contactPeople from "@/assets/resources/contactPeople.js";

import ContactMap from "@/components/contact-components/ContactMap.vue";
import ContactForm from "@/components/contact-components/ContactForm.vue";
import ContactPersonCard from "@/components/contact-components/ContactPersonCard.vue";

export default {
  components: {
    ContactMap,
    ContactForm,
    ContactPersonCard,
  },
  data() {
    return {
      contactPeople,
    };
  },
};
</script>

<style lang="scss" scoped>
.map {
  padding-bottom: 4vh;
}
.buton {
  transition: all 0.3s;
  color: white;
  background-color: #0d9599;
  align-content: center;
  margin-left: 35%;
  font-weight: bold;
  font-size: 170%;
  border-radius: 1.3550135501355014vh;
  padding: 1vh;
  width: 10%;
  // box-shadow: 2px 4px 16px 3px black;
}
.buton:hover {
  color: #f37298;
  background-color: white !important;
  font-weight: bold;
}
#contact {
  background-color: #0d2a4c;
}

@media (max-width: 600px) {
  .alt-div-2 {
    margin-left: 0;
    margin-right: 0;
    width: 100vw;
    align-content: center;
    padding-bottom: 90px;
    padding-top: 40px;
  }

  #contact-cards {
    display: inline-block;
    margin: 10px 0 0 7px;
    flex-grow: 1;
    height: 100%;
    width: calc(100% * (1 / 2) - 10px);
  }
  .box {
    max-width: 60vw;
    min-width: 120px;
    min-height: 70vw;
  }
}
@media only screen {
  .buton {
    color: white;
    background-color: #0d9599;
    align-content: center;
    margin-left: 30%;
    font-weight: bold;
    font-size: 170%;
    border-radius: 1.3550135501355014vh;
    width: 40%;
  }
  .buton:hover {
    color: #f37298;
    background-color: white !important;
    font-weight: bold;
  }
  #contact {
    background-color: #0d2a4c;
  }

  #title-contact {
    position:relative;
    color: white;
    font-size: calc(30px + (90 - 30) * ((100vw - 600px) / (3840 - 600)));
    text-align: center;
    font-family: Acumin Variable Concept;
    font-weight: light;
    margin-bottom: 5vh;
    margin-top: 15vh;
  }

  .flex-box {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    margin: auto;
    padding-bottom: 10vh;
  }

  @media (max-width: 600px) {
    .alt-div-2 {
      margin-left: 0;
      margin-right: 0;
      width: 100vw;
      align-content: center;
      padding-bottom: 90px;
      padding-top: 40px;
    }

    #contact-cards {
      display: inline-block;
      margin: 10px 0 0 7px;
      flex-grow: 1;
      height: 100%;
      width: calc(100% * (1 / 2) - 10px);
    }
    .box {
      max-width: 60vw;
      min-width: 120px;
      min-height: 70vw;
    }
    .buton {
      width: 60%;
      margin-left: 20%;
    }
  }
}
</style>
